import { IconProps } from "../../utils/global-types/global-types";

const AgentsIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-5 h-5"}
    {...rest}
  >
    <g fill="currentColor" clipPath="url(#clip0_10293_123709)">
      <path d="M9 9a3.063 3.063 0 1 0 0-6.125A3.063 3.063 0 0 0 9 9M8.201 11.52l.8.799.799-.8-.658-1.644h-.283z"></path>
      <path d="M15.025 13.582a6.11 6.11 0 0 0-3.628-4.53 3.9 3.9 0 0 1-1.369.682l.584 1.46a.88.88 0 0 1-.193.944l-.8.8a.875.875 0 0 1-1.237 0l-.8-.8a.88.88 0 0 1-.193-.943l.584-1.46a3.9 3.9 0 0 1-1.37-.682 6.11 6.11 0 0 0-3.627 4.529 1.3 1.3 0 0 0 .282 1.068 1.32 1.32 0 0 0 1.012.475h9.46a1.315 1.315 0 0 0 1.295-1.543"></path>
    </g>
    <defs>
      <clipPath id="clip0_10293_123709">
        <path fill="currentColor" d="M2 2h14v14H2z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default AgentsIcon;
